import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const HomeNotificationsSkeleton = () => {
    return (
        <Flexbox direction="column" gap={2}>
            {Array.from({length: 3}).map((_, index) => (
                <Flexbox align="center" gap={3} key={index}>
                    <Flexbox align="center" gap={1}>
                        <Skeleton width={8} height={8} style={{borderRadius: '50%'}} />
                        <Skeleton width={150} height={16} />
                    </Flexbox>
                    <Skeleton width={100} height={16} />
                </Flexbox>
            ))}
        </Flexbox>
    )
}
